<template>
  <div>
    <router-view />
  </div>
</template>

<script>
export default {
  name: "Fitting",
};
</script>

<style></style>
